let activeAttributionParams: Record<string, string> = {};
let isInitialized = false;

const keysToPersist = [
  'gclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
];

export const initializeAdAttribution = () => {
  if (typeof window === 'undefined' || isInitialized) return;
  isInitialized = true;

  try {
    // 1. Clear legacy storage keys to avoid mixed/stale data
    keysToPersist.forEach(key => {
      window.sessionStorage.removeItem(`meragi_${key}`);
      try {
        window.localStorage.removeItem(`meragi_${key}`);
      } catch (e) {}
    });

    // 2. Parse current URL parameters and populate in-memory cache
    const params = new URLSearchParams(window.location.search);
    keysToPersist.forEach(key => {
      const val = params.get(key);
      if (val) {
        activeAttributionParams[key] = val;
      }
    });

  } catch (e) {
    console.error('Failed to initialize ad attribution:', e);
  }
};

// Merges active tracking parameters into the browser's address bar without triggering Gatsby route changes.
// Intended to be called in gatsby-browser.js during onRouteUpdate.
export const carryForwardAdAttribution = () => {
  if (typeof window === 'undefined') return;

  // Initialize if not already initialized
  if (!isInitialized) {
    initializeAdAttribution();
  }

  try {
    // Priority: If the current URL has tracking parameters, update memory
    const currentParams = new URLSearchParams(window.location.search);
    keysToPersist.forEach(key => {
      const val = currentParams.get(key);
      if (val) {
        activeAttributionParams[key] = val;
      }
    });

    const active = activeAttributionParams;
    if (Object.keys(active).length === 0) return;

    const currentUrl = new URL(window.location.href);
    let changed = false;

    Object.entries(active).forEach(([key, val]) => {
      if (val && !currentUrl.searchParams.has(key)) {
        currentUrl.searchParams.set(key, val);
        changed = true;
      }
    });

    if (changed) {
      // Use replaceState to update the browser address bar without triggering a router navigation
      window.history.replaceState(
        window.history.state,
        '',
        currentUrl.pathname + currentUrl.search + currentUrl.hash
      );
    }
  } catch (e) {
    console.error('Failed to carry forward ad attribution parameters:', e);
  }
};

// Deprecated compatibility exports
export const persistAdAttributionParams = (search: string) => {
  initializeAdAttribution();
};

export const getAdAttributionParam = (key: string, urlSearch?: string): string | null => {
  if (typeof window === 'undefined') return null;

  // 1. Try URL parameters first
  const searchStr = urlSearch || window.location.search;
  if (searchStr) {
    const params = new URLSearchParams(searchStr);
    const val = params.get(key);
    if (val) return val;
  }

  // 2. Fall back to our in-memory cache
  if (activeAttributionParams[key]) {
    return activeAttributionParams[key];
  }

  return null;
};
